// Main App
import Cookies from 'js-cookie';
export { helper } from './app/helper.js';
export { user } from './app/user.js';
import Request from './app/request.js';
import Tracking from './app/tracking.js';
import Picker from './app/picker.js';

window.Tracking = new Tracking();
window.Cookies = Cookies;
window.Request = Request;
window.Picker = Picker;

Dropzone.autoDiscover = false;

const documentTitles = {
    org : '',
    focus : '',
}

document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
        const metaRendered = document.querySelector('meta[name=rendered]');
        if (metaRendered) {
            const initalRenderTime = Math.floor(metaRendered.getAttribute("content"));
            const wakeupTime = Math.floor(Date.now() / 1000);
            const diffTime = Math.floor(wakeupTime - initalRenderTime);
            if (diffTime > 1800) {
                window.location.reload(true);
            }
        }
        document.title = documentTitles.org;
    } else if (documentTitles.focus != '') {
        document.title = documentTitles.focus;
    }
}, false);

document.addEventListener('DOMContentLoaded', () => {
    const readonlys = document.querySelectorAll('.readonly');
    const moreinfos = document.querySelectorAll('.moreinfo');
    documentTitles.org = document.querySelector('meta[name=orgTitle]').getAttribute("content");
    documentTitles.focus = document.querySelector('meta[name=focusTitle]').getAttribute("content");

    if(readonlys) {
        readonlys.forEach(element => {
            element.addEventListener('mousedown', event => {
                event.preventDefault();
            });
        });
    }
    
    if(moreinfos) {
        moreinfos.forEach(element => {
            element.addEventListener('click', event => {
                const parent = event.currentTarget.closest('.detailbox');
                const details = parent.querySelector('.infos');

                if(event.currentTarget.classList.contains('active')) {
                    event.currentTarget.classList.remove('active');
                    event.currentTarget.innerHTML = 'mehr Infos';
                    details.classList.add('d-none');
                    details.classList.remove('openbox');
                } else {
                    event.currentTarget.classList.add('active');
                    event.currentTarget.innerHTML = 'weniger Infos';
                    details.classList.remove('d-none');
                    details.classList.add('openbox');
                }
                let boxheight = 0;
                const openboxes = document.querySelectorAll('.openbox');
                const uls = document.querySelectorAll('.openbox > ul');
                if(openboxes) {
                    uls.forEach(ul => {
                        if(ul.offsetHeight > boxheight) {
                            boxheight = ul.offsetHeight;
                        }
                    });
                    openboxes.forEach(openbox => {
                        openbox.style.height = (boxheight + 43) + 'px';
                    });
                }
            });
        });
    }
});

/**
 * Countdown
 *
 * @prop HTMLobject container The container element of the countdown template
 */
 window.countdown = {
    container: document.getElementById('countdown'),

    /**
     * Start the countdown
     *
     * @param Integer time The time span in milliseconds the countdown should run
     */
    start: function(time, reload = true) {
        this.container = document.getElementById('countdown');
        const days = this.container.querySelector('div.days i');
        const hours = this.container.querySelector('div.hours i');
        const minutes = this.container.querySelector('div.minutes i');
        const seconds = this.container.querySelector('div.seconds i');

        this.interval = setInterval(() => {
            const distance = time * 1000 - new Date().getTime();

            if(distance > 0) {
                days.innerHTML = Math.floor(distance / (1000 * 60 * 60 * 24));
                hours.innerHTML = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                minutes.innerHTML = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                seconds.innerHTML = Math.floor((distance % (1000 * 60)) / 1000);
            } else {
                clearInterval(this.interval);
                if (reload) {
                    window.location.reload(true);
                }
            }
        }, 1000);
    }
};
